import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
const dataList = [
  { name: "Page A", uv: 4000, pv: 2400, amt: 2400 },
  { name: "Page B", uv: 3000, pv: 1398, amt: 2210 },
  { name: "Page C", uv: 2000, pv: 9800, amt: 2290 },
  { name: "Page D", uv: 2780, pv: 3908, amt: 2000 },
  { name: "Page E", uv: 1890, pv: 4800, amt: 2181 },
  { name: "Page F", uv: 2390, pv: 3800, amt: 2500 },
];
export default function BarComp() {
  return (
    <div className="bar-chart-container">
      <ResponsiveContainer> 
        <BarChart data={dataList} margin={{right: 10}}>
          <XAxis dataKey="name"/>
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
          <Tooltip/>
          <Legend/>
          <Bar type="monotone" dataKey="uv" fill="#ca03ca"/>
          <Bar type="monotone" dataKey="pv" fill="#801994"/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}